import { AnalyticsContextValue } from "@swiggy-private/checkout-core";

import { CLICK_ACTIONS, IMPRESSION_ACTIONS, SCREEN_NAME } from "../constants";

/** Cart events pass a prebuilt context string; screen category comes from AnalyticsOverrideProvider. */
export const impressionCart = ({
    impressionEvent,
    context,
}: {
    impressionEvent: AnalyticsContextValue["impressionEvent"];
    context: string;
}): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_CART,
        context,
    });
};

export const clickViewCart = ({
    clickEvent,
    context,
}: {
    clickEvent: AnalyticsContextValue["clickEvent"];
    context: string;
}): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_VIEW_CART,
        context,
    });
};

/** Fired when the QC header web savings expand animation is shown. */
export const impressionAipSavingsAnimation = ({
    impressionEvent,
    amount,
}: {
    impressionEvent: AnalyticsContextValue["impressionEvent"];
    amount: number | string;
}): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_AIP_SAVINGS_ANIMATION,
        label: String(amount),
        context: "-",
    });
};
